import { configureStore } from "@reduxjs/toolkit";

/*********** reducers imports ************/
import applicationsReducer from "../app/slices/applicationsSlice";
import attachmentsReducer from "../app/slices/attachmentsSlice";
import authReducer from "../app/slices/authSlice";
import commentReducer from "../app/slices/commentSlice";
import commonReducer from "../app/slices/commonSlice";
import reportsReducer from "../app/slices/reportSlice";
import risksReducer from "../app/slices/risksSlice";
import solutionsReducer from "../app/slices/solutionsSlice";
import stakeholdersReducer from "../app/slices/stakeholdersSlice";
import usersReducer from "../app/slices/usersSlice";
/*********** reducers imports ************/

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    common: commonReducer,
    applications: applicationsReducer,
    attachments: attachmentsReducer,
    stakeholders: stakeholdersReducer,
    risks: risksReducer,
    solutions: solutionsReducer,
    comments: commentReducer,
    reports: reportsReducer,
  },
});
